import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { AddPurchaseOrderButton } from '../../../purchase-orders/add-purchase-order-button';
import { messages } from '../../messages';
import { SellerFeatures } from '../../../../../enums/seller-features';
import { useIsSellerFeatureEnabled } from '../../../../../hooks/use-is-seller-feature-enabled';
import type { Supplier } from '../../types/supplier-types';
import type { SupplierProduct } from '../../types/supplier-product-types';

type CreatePurchaseOrderButtonProps = {
  supplier: Supplier | null;
  selectedProducts: SupplierProduct[];
};

export const CreatePurchaseOrderButton = ({ supplier, selectedProducts }: CreatePurchaseOrderButtonProps) => {
  const intl = useIntl();
  const isInventoryReorderingEnabled = useIsSellerFeatureEnabled(SellerFeatures.InventoryReordering);

  const initializedPurchaseOrder = useMemo(
    () => ({
      supplierId: supplier?.supplierId,
      selectedProductsWithQuantity: selectedProducts.map((sp) => ({
        productId: sp.productId,
        quantity: 1,
        supplierSku: sp.supplierSku,
        cost: sp.cost,
      })),
    }),
    [supplier?.supplierId, selectedProducts],
  );

  const text = intl.formatMessage(messages.createPurchaseOrderButton);
  const isDisabled = !isInventoryReorderingEnabled || selectedProducts.length === 0;

  return (
    <AddPurchaseOrderButton
      disabled={isDisabled}
      initializedPurchaseOrder={initializedPurchaseOrder}
      text={text}
      theme={THEME_CONSTANTS.tertiary}
    />
  );
};
